import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AssessmentProfileService } from "src/app/_services/assessment-profile.service";
import { GetAssessmentProfile, GetAssessmentProfileError, GetAssessmentProfileSuccess } from "./assessment-profile.actions";
import { catchError, map, switchMap } from "rxjs/operators";
import { AssessmentProfileResult } from "src/app/_models/AssessmentProfileResultDto";
import { HttpErrorResponse } from "@angular/common/http";
import { of } from "rxjs";

@Injectable()
export class AssessmentProfileEffects {
  constructor(
    private actions$: Actions,
    private assessmentProfileService: AssessmentProfileService
  ) {}

  public getAssessmentProfileResultEffects$ = createEffect(() => 
    this.actions$.pipe(
      ofType(GetAssessmentProfile),
      switchMap((payload) => 
        this.assessmentProfileService.getAssessmentProfileResult$(payload.learnerId, payload.courseId)
        .pipe(
          map((result: AssessmentProfileResult) => {
            return GetAssessmentProfileSuccess({result: result});
          }),
          catchError((error: HttpErrorResponse) => {
            return of(GetAssessmentProfileError({error: error}));
          }),
        )
      )
    )
  );
}